
import React from 'react';
import { Button } from 'antd';

export const isImg = /^(http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?)|([\w\-./]*(\.jpg|\.jpeg|\.png|\.gif|\.bmp|\.svg)$)/i;
export const getChildrenToRender = (item, i) => {
  let tag = item.name.indexOf('title') === 0 ? 'h1' : 'div';
  tag = item.href ? 'a' : tag;
  let children = typeof item.children === 'string' && item.children.match(isImg);
  
  // 处理图片路径：根据React应用的资源引用规则
  let imgSrc = item.children;
  if (children && imgSrc && !imgSrc.startsWith('http')) {
    // 在React中，src目录下的静态资源需要通过正确的导入方式引用
    // 提取文件名
    const fileName = imgSrc.split('/').pop();
    
    try {
      // 尝试直接导入图片（这种方式需要webpack配置支持）
      const importedImage = require(`../../../src/static/活动图片/${fileName}`);
      children = React.createElement('img', { src: importedImage, alt: 'img' });
    } catch (error) {
      // 如果导入失败，回退到使用public目录的相对路径
      // 注意：在React应用中，静态资源应该放在public目录下
      console.warn(`无法导入图片: ${fileName}，尝试使用public目录路径`);
      children = React.createElement('img', { src: `/static/活动图片/${fileName}`, alt: 'img' });
    }
  } else if (typeof item.children === 'string') {
    children = item.children;
  } else {
    children = item.children;
  }
  
  if (item.name.indexOf('button') === 0 && typeof item.children === 'object') {
    children = React.createElement(Button, {
      ...item.children
    });
  }
  return React.createElement(tag, { key: i.toString(), ...item }, children);
};
